module.exports = __webpack_public_path__ + "static/media/nexus.138a7418.png";